import Stack from "@mui/material/Stack";
import SectionHeader from "../../../../util/component/SectionHeader";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { CBCreationOfProps, CBOmissionType, CBPartnerType, CustomerBaseDto } from "../../types";
import { useTranslation } from "react-i18next";
import Hidden from "@mui/material/Hidden";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CustomerBaseState from "./CustomerBaseState";
import RegistryPhaseDetails from "./RegistryPhaseDetails";
import CBDigitalIdentity from "./CBDigitalIdentity";
import CBDigitalIdentityStatus from "./CBDigitalIdentityStatus";

interface CBSectionHeaderProps extends CBCreationOfProps {
    customer: CustomerBaseDto | null 
}
const CBSectionHeader = ({customer, creationOf} : CBSectionHeaderProps) => {

    const { t } = useTranslation("customerbase");
    const isCreationMode = !!creationOf;
    const isPersonCreation = creationOf == "person";

    const getField = (translationLabel: string, field: string | null | undefined) => {
        
        return (
            <Stack direction="row" alignItems="end" columnGap={1}>
                <Typography variant="subtitle2">{t(`${translationLabel}`)}:</Typography>
                <Typography>{!!field ? field : CBOmissionType.OMISSION_DASH}</Typography>
            </Stack>
        );
    }

    return (
        <SectionHeader 
            title={
                <Stack direction={{sm: "row", xs: "column"}} alignItems={{sm: "center", xs: "flex-start"}} gap={1}>
                    {/*<IconButton color="primary" onClick={() => {
                        if(formState.isDirty) 
                            setOpenModal(true); 
                        else 
                            navigate(-1);
                        }} 
                        style={{padding: 0}}
                    >
                        <ArrowBackOutlined />
                    </IconButton>*/}
                    {isCreationMode &&
                        <Box>
                            {isPersonCreation ? t("headers.createCustomerbaseTitle") : t("headers.createOrganizationTitle")}
                        </Box>
                    }
                    {!isCreationMode &&
                        <>
                            {customer?.partnerType ?
                                (customer?.partnerType == CBPartnerType.PERSON  ? 
                                        (customer.registry?.lastName && customer.registry?.firstName ? (customer.registry?.lastName + ' ' + customer.registry?.firstName) : t("headers.viewCustomerbaseTitle"))
                                    : 
                                        (customer.registry?.businessName ? customer.registry?.businessName : t("headers.viewOrganizationTitle"))
                                )
                            :
                            t("headers.viewCustomerbaseTitle")}
                            <CustomerBaseState />
                            <CBDigitalIdentity /> 
                            <CBDigitalIdentityStatus />
                        </>
                    }
                </Stack> 
            }
            subtitle={
                !isCreationMode && (
                    <>
                    <Hidden lgDown>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                            <Stack direction="row" alignItems="center" columnGap={3}>
                                {getField("cbCustomerId", customer?.cbCustomerId)}
                                {getField("bpCode", customer?.bpCode)}
                                {getField(customer?.partnerType == CBPartnerType.PERSON ? "taxCode" : "companyFiscalCode", customer?.registry?.taxCode)}
                                {getField("vatNumber", !!customer?.registry?.vatNumberCountry && !!customer?.registry?.vatNumber ? (customer?.registry?.vatNumberCountry + customer.registry?.vatNumber) : (!!customer?.registry?.vatNumber ? customer?.registry?.vatNumber : ''))}
                                {(customer?.partnerType == CBPartnerType.PERSON) && getField("drvLicenceNumber", customer?.registry?.drvLicenceNumber)}
                            </Stack>
                            {/*<Stack direction="row" columnGap={2}>
                                {
                                    currentCB?.businessLines?.map((bl, index) => 
                                        <Chip
                                            key={`lgUp-chip-bl-detail-${index}`}
                                            label={t(`sapEnum.businessLines.${bl.description}`)}
                                            color={bl.status == "0" ? "default" : (bl.status == "1" ? "success" : "error") }

                                        />
                                    )
                                }
                            </Stack>*/}
                            <RegistryPhaseDetails/>
                        </Stack>
                    </Hidden> 
                    <Hidden lgUp>
                        <Grid container alignItems="center">
                            <Grid item lg={0.5} md={4} xs={12}>
                                {getField("cbCustomerId", customer?.cbCustomerId)}
                            </Grid>
                            <Grid item lg={1} md={4} xs={12}>
                                {getField("bpCode", customer?.bpCode)}
                            </Grid>
                            <Grid item lg={2} md={4} xs={12}>
                                {getField(customer?.partnerType == CBPartnerType.PERSON ? "taxCode" : "companyFiscalCode", customer?.registry?.taxCode)}
                            </Grid>
                            <Grid item lg={2} md={4} xs={12}>
                                {getField("vatNumber", !!customer?.registry?.vatNumberCountry && !!customer?.registry?.vatNumber ? (customer?.registry?.vatNumberCountry + customer.registry?.vatNumber) : (!!customer?.registry?.vatNumber ? customer?.registry?.vatNumber : ''))}
                            </Grid>
                            <Grid item lg={2} md={4} xs={12}>
                                {(customer?.partnerType == CBPartnerType.PERSON) && getField("drvLicenceNumber", customer?.registry?.drvLicenceNumber)}
                            </Grid>
                            {/*<Grid item lg={12} md={12} xs={12}>
                                <Stack direction="row" columnGap={2} sx={{paddingTop: 1}}>
                                    {
                                        currentCB?.businessLines?.map((bl, index) => 
                                            <Chip
                                                key={`lgDown-chip-bl-detail-${index}`}
                                                label={t(`sapEnum.businessLines.${bl.description}`)}
                                                color={bl.status == "0" ? "default" : (bl.status == "1" ? "success" : "error") }
                                            />
                                        )
                                    }
                                </Stack>
                            </Grid>*/}
                            <RegistryPhaseDetails />
                        </Grid>
                    </Hidden>
                    </>
                )
            }
        />

    );

}

export default CBSectionHeader;